import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Link' })((theme) => ({
  linkBase: {
    lineHeight: 'inherit',
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  displayAsBlock: {
    display: 'block',
  },
  displayInline: {
    display: 'inline',
  },
}));

export default useStyles;
